import database from 'database'

export default store => {
  store.subscribe(async (mutation, state) => {
    if (mutation.type === 'ui/changeSideMenuStatus') {
      const settings = await database.Settings.toCollection().first() || {}

      database.Settings.put({
        ...settings,
        id: 1,
        menu: 'store.state.menu.menuType'
      })
    }
  })
}
